import Select from "react-select";

import { loginByEmail, loginByPhoneNo } from "../../utils/Constants";

import { customStylesbusiness } from "../../utils/commonFunctions";

function BusinessOverviewSection({
  businessName,
  setBusinessName,

  agentName,
  setAgentName,

  experience,
  setExperience,

  Email,
  setEmail,

  countries,
  countryCode,
  setCountryCode,

  states,
  selectedState,
  setSelectedState,

  cities,
  selectedCity,
  setSelectedCity,

  address,
  setAddress,

  description,
  setDescription,

  loginby,

  PhoneNumber,
  selectedCountryCode,

  businessRegistrationNo,
  setBusinessRegistrationNo,
}) {
  return (
    <div className="Business-container mt-4">
      <h2>Business overview</h2>

      <div className="field">
        <label>Business Name *</label>

        <input
          type="text"
          placeholder="Enter Business Name"
          value={businessName}
          onChange={(e) => setBusinessName(e.target.value)}
        />
      </div>

      <div className="field">
        <label>Your Agent Name *</label>

        <input
          type="text"
          placeholder="Enter Your Name"
          value={agentName}
          onChange={(e) => setAgentName(e.target.value)}
        />
      </div>

      <div className="field">
        <label>Total Business Experience (in years) *</label>

        <input
          type="text"
          inputMode="numeric"
          placeholder="e.g. 5"
          value={experience}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              setExperience(value);
            }
          }}
        />
      </div>

      {loginby === loginByPhoneNo && (
        <div className="field">
          <label>Phone Number</label>

          <div style={{ display: "flex", gap: 8 }}>
            {selectedCountryCode && (
              <input
                type="text"
                value={`+${selectedCountryCode}`}
                disabled
                style={{ width: 80, flex: "none" }}
              />
            )}
            <input type="text" value={PhoneNumber || ""} disabled />
          </div>
        </div>
      )}

      {loginby === loginByPhoneNo && (
        <div className="field">
          <label>Enter Email (optional)</label>

          <input
            type="email"
            placeholder="email"
            value={Email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      )}

      {loginby === loginByEmail && (
        <div className="field">
          <label>Email</label>

          <input type="email" value={Email} disabled />
        </div>
      )}

      <div className="field">
        <label>Select Country *</label>

        <Select
          options={countries}
          placeholder="Select Country"
          value={countries.find((c) => c.value === countryCode) || null}
          onChange={(option) => setCountryCode(option.value)}
          isSearchable
          styles={customStylesbusiness}
        />
      </div>

      <div className="field">
        <label>Select State *</label>

        <Select
          options={states}
          placeholder="Select State"
          value={selectedState}
          onChange={(option) => setSelectedState(option)}
          isDisabled={!countryCode}
          isSearchable
          styles={customStylesbusiness}
        />
      </div>

      <div className="field">
        <label>Select City *</label>

        <Select
          options={cities}
          placeholder="Select City"
          value={selectedCity}
          onChange={(option) => setSelectedCity(option)}
          isDisabled={!selectedState}
          isSearchable
          styles={customStylesbusiness}
        />
      </div>

      <div className="field">
        <label>Business Address *</label>

        <textarea
          placeholder="Business Address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          rows={4}
        />
      </div>

      <div className="field">
        <label>Business introduction (Optional)</label>

        <textarea
          placeholder="Business Introduction"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={6}
        />
      </div>
      <div className="field">
        <label>Registration No (optional)</label>

        <input
          type="text"
          placeholder="Enter Registration No (optional)"
          onChange={(e) => setBusinessRegistrationNo(e.target.value)}
        />
      </div>
    </div>
  );
}

export default BusinessOverviewSection;
